import { doc } from 'firebase/firestore/lite'

const getDoc = (collection) => doc(collection)

export default getDoc
